export const dkResources = {
  translation: {
    Onboarding: "Onboarding",
    Select: "Bekræft",
    Add: "Tilføj",
    Cancel: "Annuller",
    Next: "Næste",
    Previous: "Forrige",
    "See all": "Se alle",
    Submitted: "Indsendt",
    Submit: "Indsend",
    Confirm: "Bekræft",
    Required: "Påkrævet",
    "Onboarding successful": "Onboarding succesfuld",
    "Onboarding failed - contact evsupport@eplucon.nl":
      "Onboarding mislykkedes - kontakte evsupport@eplucon.nl",

    "Let's get started": "Lad os komme i gang!",
    "Onboard your charger in just a few steps": "Ombord din oplader på få trin",
    "Onboarding is now complete": "Onboarding er nu fuldført",

    // Start
    "This onboarding tool is intended for new users of Monta. For expansion, please contact Eplucon.":
      "Dette onboarding-værktøj er beregnet til nye brugere af Monta. For udvidelse, kontakt venligst Eplucon.",

    // Side carousel
    "Onboard your charging station at Monta and you can start immediately. Monta gives you plenty of options to use your charging station the way you want. Determine your own rates and to whom which rate applies, or set free charging. It's all possible with Monta!":
      "An Bord Ihrer Ladestation in Monta können Sie sofort loslegen. Monta bietet Ihnen viele Möglichkeiten, Ihre Ladestation so zu nutzen, wie Sie es möchten. Bestimmen Sie Ihre eigenen Tarife und für wen dieser Tarif gilt, oder legen Sie eine kostenlose Abrechnung fest. Mit Monta ist alles möglich!",

    // Tier options
    Basic: "Basic",
    "Charging at home, visitor can only charge with own Monta account. (Maximum 3 charging points)":
      "Opladning derhjemme, besøgende kan kun oplade med egen Monta-konto. (Maksimalt 3 ladepunkter)",
    Sponsored: "Sponsored",
    "Charging at home with automatic settlement between employer and employee.":
      "Opladning derhjemme med automatisk afregning mellem arbejdsgiver og medarbejder.",
    Commercial: "Commercial",
    "The best solution for commercial charging for both companies and private individuals with all functionalities.":
      "Den bedste løsning til kommerciel opladning for både virksomheder og private personer med alle funktionaliteter.",

    Costs: "Omkostninger",
    Subscription: "Abonnement",
    "Paid charging session": "Betalt opladningssession",
    "Free or sponsored charging session":
      "Gratis eller sponsorerede opladningssessioner",
    "Basis (incl. VAT)": "Basis (inkl. moms)",
    Free: "Gratis",
    "0.24 starting rate and 7.5% per transaction":
      "0.24 startpris og 7.5% pr. transaktion",
    "0.24 starting rate, no transaction costs":
      "0.24 startpris, ingen transaktionsomkostninger",
    "Sponsored (excl.. VAT)": "Sponsored (ekskl.. moms)",
    "€ 7,44": "€ 7,44",
    "0.20 starting rate and 7.5% per transaction":
      "0.20 startpris og 7.5% pr. transaktion",
    "0.20 starting rate, no transaction costs":
      "0.20 startpris, ingen transaktionsomkostninger",
    "Commercial (excl. VAT)": "Erhverv (ekskl. moms)",

    // Plan details
    "Unlimited Team Members": "Ubegrænsede teammedlemmer",
    "Monthly Cost": "Månedlige omkostninger",
    "Transaction Fee": "Transaktionsgebyr",
    "Tech Support": "Teknisk support (kun for administratorer / ejere)",
    "24/7 Support": "24/7 support",
    Portal: "Portal",
    Dashboard: "Dashboard",
    "Transaction Overview": "Transaktionsoversigt",
    "Smart Queue": "Smart kø",
    "Load Balancing": "Lastbalancering",
    "Advanced Features": "Avancerede funktioner",
    "Pay with team wallet": "Betal med team wallet",
    "Team charge keys": "Team opladningsnøgler",
    "Pay by invoice": "Betal med faktura",
    "Sponsored chargepoints": "Sponsorerede ladestationer",
    Roaming: "Roaming",
    "Enterprise security": "Virksomhedssikkerhed",

    // Chargepoint
    Chargepoint: "Ladepunkt",
    "Search Serial Number": "Søg serienummer",
    "Add Sim": "Tilføj Sim",
    "Additional €8/month per sim": "Yderligere €8/måned pr. sim",
    Chargepoints: "Ladepunkter",
    Connectors: "Forbindelser",
    Summary: "Resumé",
    "Serial Number": "Serienummer",
    Model: "Model",
    "Max Power": "Maksimal effekt",

    // Company
    Company: "Firma",
    Name: "Navn",
    "Optional (for companies)": "Valgfrit (for virksomheder)",
    "Search Address": "Søg adresse",
    Street: "Gade",
    City: "By",
    "Zip Code": "Postnummer",
    Country: "Land",

    // Guidance text
    "Something went wrong, please try again": "Noget gik galt, prøv igen",
    "Please enter a valid serial number": "Indtast et gyldigt serienummer",
    "Please add a chargepoint": "Tilføj et ladepunkt",
    "Please enter a valid street": "Indtast en gyldig gade",
    "Please enter a valid city": "Indtast en gyldig by",
    "Please enter a valid zip code": "Indtast en gyldig postnummer",
    "Please enter a valid name": "Indtast et gyldigt navn",
    "Please enter a valid email": "Indtast en gyldig e-mail",
    "Please enter a valid telephone number": "Indtast et gyldigt telefonnummer",

    // The rest
    "Team Name": "Team navn",
    "Team Owner": "Team ejer",
    "Owner Name": "Ejerens navn",
    "Owner Telephone": "Ejerens telefonnummer",
    "Owner Email": "Ejerens e-mail",
    "Team Finance": "Team økonomi",
    "Finance Name": "Økonomi navn",
    "Finance Telephone": "Økonomi telefonnummer",
    "Finance Email": "Økonomi e-mail",
    "Team Installer": "Team installatør",
    "Installer Name": "Installatørens navn",
    "Installer Telephone": "Installatørens telefonnummer",
    "Installer Email": "Installatørens e-mail",
    "Installation Notes (optional)": "Installationsnoter (valgfrit)",
    Site: "Sted",
    "Site Name": "Stednavn",
  },
};
